/* eslint-disable */
import axios from '@/axios.js';

export const userManagementApi = {
  getAdmins(payload) {
    return axios.get('/admins', {
      params: payload,
    });
  },
  getAdmin(id) {
    return axios.get(`/admins/${id}`);
  },
  addAdmin(body) {
    return axios.post('/admins', body);
  },
  updateAdmin(id, body) {
    return axios.patch(`/admins/${id}`, body);
  },
  deleteAdmin(id) {
    return axios.delete(`/admins/${id}`);
  },
  updateAdminPassword(body) {
    return axios.post('/admin/auth/change-password', body);
  },
  getUsers(payload) {
    return axios.get(`/users`, {
      params: payload,
    });
  },
  getUser(id) {
    return axios.get(`/users/${id}`);
  },
  getUserTransactions({ id, ...payload }) {
    return axios.get(`/users/${id}/transactions`, {
      params: payload,
    });
  },
  getUserSubscriptions({ id, ...payload }) {
    return axios.get(`/users/${id}/subscriptions`, {
      params: payload,
    });
  },
  updateUser(id, body) {
    return axios.patch(`/users/${id}`, body);
  },
};
